<div class="pu-floating-label-outline__start"></div>
<div class="pu-floating-label-outline__gap" *ngIf="label" [class.pu-floating-label-outline__gap_small]="labelSize === 's'">
  <div class="pu-floating-label-outline__gap-inner" aria-hidden="true">
    {{ label }}
  </div>
</div>
<div class="pu-floating-label-outline__end"></div>
